// extracted by mini-css-extract-plugin
module.exports = {"giftaid":"giftaid__PE7YC"};